module.exports = __webpack_public_path__ + "media/src/images/icons/external_link-a73863139f50a2947d46ff07e1f82959.svg";